export const overridableComponentIds = [
  "Errors.container",
  "FormActions.container",
  "FormApp.layout",
  "FormFields.container",
  "CustomFields.container",
];
